/* GPNVG-18 round 4, 14 Oct 2026: FOM slider in the dark order card (Bon: sliders, not pills, on every page).
   The four tier buttons ([data-ng-fom]) stay in the page, hidden, and keep driving the price, the cart and the tube
   grade section; the slider only presses them. Prices and sold out state are read from those buttons, so they stay
   the live ones. No em or en dashes. */
(function () {
  "use strict";
  var root = document.getElementById("no-gpnvg18");
  if (!root || root.dataset.ng4Ready) return;
  root.dataset.ng4Ready = "true";

  var pills = Array.from(root.querySelectorAll("#ng-bundles [data-ng-fom]"));
  if (pills.length < 2) return;
  var row = pills[0].parentNode;
  var TIERS = pills.map(function (p) { return p.dataset.ngFom; });
  var N = TIERS.length;
  var sold = function (i) { var p = pills[i]; return !!(p.disabled || p.getAttribute("aria-disabled") === "true"); };
  var priceOf = function (i) { var e = pills[i].querySelector("[data-ng-tier-price]"); return e ? e.textContent.trim() : ""; };
  var current = function () { for (var i = 0; i < N; i++) if (pills[i].getAttribute("aria-pressed") === "true") return i; return 0; };

  var box = document.createElement("div");
  box.className = "ng4-fom";
  box.setAttribute("data-ng4-fom", "");
  var stops = TIERS.map(function (t, i) { return '<button type="button" class="ng4-stop" data-ng4-stop="' + i + '">' + t + '<small data-ng4-sp="' + i + '"></small></button>'; }).join("");
  var dots = TIERS.map(function (t, i) { return '<i class="ng4-dot" data-ng4-dot="' + i + '" style="left:' + (i / (N - 1) * 100) + '%"></i>'; }).join("");
  box.innerHTML = '<div class="ng4-fom-top"><span class="ng4-fom-pick" data-ng4-pick></span><span class="ng4-fom-price" data-ng4-price></span></div>' +
    '<div class="ng4-rail"><span class="ng4-fill" data-ng4-fill></span>' + dots +
    '<input type="range" class="ng4-range" min="0" max="' + (N - 1) + '" step="1" value="0" aria-label="FOM tier, slide to pick">' +
    '<span class="ng4-thumb" data-ng4-thumb></span></div>' +
    '<div class="ng4-stops">' + stops + '</div><p class="ng4-fom-note" data-ng4-note></p>';
  row.parentNode.insertBefore(box, row.nextSibling);
  row.classList.add("ng4-pills-hidden");
  row.setAttribute("aria-hidden", "true");
  pills.forEach(function (p) { p.tabIndex = -1; });

  var range = box.querySelector(".ng4-range");
  var paint = function () {
    var k = current();
    range.value = String(k);
    range.setAttribute("aria-valuetext", TIERS[k] + " FOM, " + priceOf(k));
    var pct = (k / (N - 1) * 100) + "%";
    box.querySelector("[data-ng4-fill]").style.width = pct;
    box.querySelector("[data-ng4-thumb]").style.left = pct;
    box.querySelector("[data-ng4-pick]").textContent = TIERS[k] + " FOM";
    box.querySelector("[data-ng4-price]").textContent = priceOf(k);
    box.querySelectorAll("[data-ng4-dot]").forEach(function (d) { var i = +d.dataset.ng4Dot; d.classList.toggle("is-on", i <= k && !sold(i)); d.classList.toggle("is-sold", sold(i)); });
    box.querySelectorAll("[data-ng4-stop]").forEach(function (b) {
      var i = +b.dataset.ng4Stop, s = sold(i);
      b.classList.toggle("is-on", i === k); b.classList.toggle("is-sold", s);
      b.setAttribute("aria-pressed", String(i === k)); b.setAttribute("aria-disabled", String(s));
      b.title = TIERS[i] + " FOM: " + priceOf(i) + (s ? ", sold out" : "");
    });
    box.querySelectorAll("[data-ng4-sp]").forEach(function (e) { var i = +e.dataset.ng4Sp; e.textContent = sold(i) ? "SOLD OUT" : priceOf(i); });
    var gone = TIERS.filter(function (t, i) { return sold(i); });
    box.querySelector("[data-ng4-note]").textContent = "Higher FOM, sharper and cleaner picture." + (gone.length ? " " + gone.join(", ") + " is sold out." : "");
  };
  var pick = function (k) {
    k = Math.max(0, Math.min(N - 1, k | 0));
    if (sold(k)) {   // snap back to the nearest tier that can be bought
      var best = -1;
      for (var d = 1; d < N && best < 0; d++) { if (k - d >= 0 && !sold(k - d)) best = k - d; else if (k + d < N && !sold(k + d)) best = k + d; }
      if (best < 0) { paint(); return; }
      k = best;
    }
    if (current() !== k) pills[k].click();
    paint();
  };
  range.addEventListener("input", function () { pick(+range.value); });
  range.addEventListener("change", function () { pick(+range.value); });
  box.querySelectorAll("[data-ng4-stop]").forEach(function (b) { b.addEventListener("click", function () { pick(+b.dataset.ng4Stop); }); });
  // follow the buttons when anything else changes them (the tube grade section, stock loading, colour change)
  if ("MutationObserver" in window) {
    var raf = 0, mo = new MutationObserver(function () { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; paint(); }); });
    pills.forEach(function (p) { mo.observe(p, { attributes: true, attributeFilter: ["aria-pressed", "disabled", "aria-disabled"], childList: true, subtree: true, characterData: true }); });
  }
  paint();
})();
